import { NavLink } from "react-router";
import Icon from "../../components/Icon";
import KeyboardArrowRight from "../../components/icons/keyboard_arrow_right.svg?react";
import { Bike } from "../../http/onlyclicksApi";
import styles from "./BikeList.module.css";

interface Props {
  bikes: Bike[] | undefined;
  selectedBike?: string;
}

const BikeList = ({ bikes }: Props) => {
  return (
    <ul className={styles.bikes}>
      {bikes &&
        bikes.map((bike) => {
          return (
            <li key={bike.id}>
              <NavLink to={bike.id} className={styles.bike}>
                {bike.name}
                <Icon
                  glyph={KeyboardArrowRight}
                  className={styles.arrowRight}
                />
              </NavLink>
            </li>
          );
        })}
    </ul>
  );
};

export default BikeList;
